import { Component, OnInit } from '@angular/core';
import { TipoService } from '../../services/tipo.service';
import { Tipo } from '../../model/tipo';

@Component({
  selector: 'app-tipos',
  templateUrl: './tipos.component.html',
  styleUrls: ['./tipos.component.css']
})
export class TiposComponent implements OnInit {

  public modoEdicion: boolean = false;
  public tipoSeleccionado: Tipo = new Tipo();
  public tipos: Tipo[];
  public filtro:string;
  constructor(
    private _tipoService: TipoService
  ) { }

  ngOnInit() {
     this.filtro = "";
    this.tipos = [];
    this.refrescarTipos();
  }

  refrescarTipos() {
    this._tipoService.getTipos()
      .subscribe(
      data => {
        this.tipos = data.filter(tipo => tipo.tipo === "PRESENTACIONBASE" || tipo.tipo === "PRESENTACIONEMPAQUE");
      },
      err => {
        console.log(err);
      });
  }


  agregarRegistro() {
    this.tipoSeleccionado = new Tipo();
    this.modoEdicion = true;
  }

  onSubmit() {
    this._tipoService.insert(this.tipoSeleccionado)
      .subscribe(
      data => {
        if (data.Resultado === "codigoTipo ya existe en la base de datos") {
          alert("Error: El código de Tipo ya existe");
        }else{
          this.regresar();
        }
      },
      err => {
        console.log(err);
      });
  }

  eliminarTipo(_tipo: Tipo) {
    if (confirm("¿Realmente desea eliminar el tipo: " + _tipo.codigoTipo + "?")) {
      this._tipoService.delete(_tipo)
        .subscribe(
        data => {
          if(data.Resultado === true){
          alert("Tipo Presentación eliminado con éxito");
          this.regresar();
          }else{
            alert("Error eliminando el Tipo");
          }
        },
        err => {
          alert("Error eliminando el Tipo");
          console.log(err);
        });
    }
  }


  regresar() {
    this.refrescarTipos();
    this.modoEdicion = false;
  }


}




// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/tipos/tipos.component.ts